<template>
  <el-dropdown class="components-user-header cursor-pointer">
    <span class="el-dropdown-link">
      <span class="user-header-image iconfont">
        <img src="../../common/images/headerImage.png" alt="" />
      </span>
      {{ userData.name }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <!-- <el-dropdown-item>
        <router-link to="/personal">
          <span class="iconfont" style="color:#999 !important;"
            >&#xe67d;&nbsp;个人信息</span
          >
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item>
        <resetPassword>
          <span class="iconfont">&#xe67f;&nbsp;修改密码</span>
        </resetPassword>
      </el-dropdown-item> -->
      <el-dropdown-item>
        <div @click="logout">
          <span class="iconfont">&#xe67e;&nbsp;退出登录</span>
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import resetPassword from '../reset-password';

export default {
  name: 'user-header-bar',
  components: {
    resetPassword
  },
  computed: {
    ...mapState({
      userData: state => state.user.userData
    })
  },
  methods: {
    logout() {
      localStorage.removeItem('path');
      this.$store.dispatch('doLogout');
    }
  }
};
</script>

<style lang="scss" scoped>
.user-header-image {
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 4px;
  font-size: 32px;
  line-height: 32px;
  text-align: center;
  margin-top: -5px;
}
</style>
